module.exports = __webpack_public_path__ + "img/GetAppOutlined.604722c7.svg";